import React from 'react';
import ArrayInput from '../Partials/ArrayInput';

import { Form, Row, Col, Button } from 'antd';

function hasErrors(fieldsError) {
    //console.log('hasErrors', fieldsError);
    //return Object.keys(fieldsError).some(field => fieldsError[field]);
}

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
};
function updateDotted(dottedString, reference, pointer, value) {
    let fieldParts = dottedString.split('.');
    if (fieldParts[pointer + 1] == undefined) {
        reference[fieldParts[pointer]] = value;
    }
    else {
        updateDotted(dottedString, reference[fieldParts[pointer]], pointer + 1, value);
    }
}

class GeneralForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = props.initialData ? props.initialData : {};
    }

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                {this.buildFormFields()}
                <Form.Item>
                    <div className="btn-container">
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={this.props.submitted}
                            >
                            {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        );
    }

    buildFormFields() {
        var columns = this.props.options.columns;
        var fieldArray = [];
        for (let c in columns) {
            if (typeof columns[c] == typeof []) {
                for (let f in columns[c]) {
                    let field = columns[c][f];
                    fieldArray.push(<div key={'row-'+c+'-'+f}>{this.buildFormField(field, c)}</div>);
                }
            }
        }
        return fieldArray;
    }

    buildFormField(field, group = null) {
        const { getFieldDecorator, getFieldsError } = this.props.form;
        if (field.partial != undefined) {
            return this.buildFormPartial(field, getFieldDecorator, group);
        }
        else if (field.sub_fields != undefined) {
            let fieldArray = [];
            for (let i in field.sub_fields) {
                let sub_field = field.sub_fields[i];
                fieldArray.push(<div
                    key={'sub-row'+field.field+'-'+sub_field.field}>{this.buildFormField(sub_field, group + "." + field.field)}</div>);
            }
            return fieldArray;
        }
    }

    buildFormPartial(field, getFieldDecorator, group = null) {
        let Handler = field.partial.handler;
        let props = field.partial.props ? field.partial.props : {};
        let attributes = {};
        for (let p in props) {
            if (isFunction(props[p]) && p !== "update") {
                let func = props[p];
                attributes[p] = func(this);
            }
            else {
                attributes[p] = props[p];
            }
        }
        attributes["field"] = group ? group + "." + field.field : field;
        if(attributes["update"] == undefined){
            attributes["update"] = (value, field) => {
                this.update(attributes["field"], value)
            }
        }
        return <Handler formHandler={this} getFieldDecorator={getFieldDecorator} {...attributes}/>;
    }

    getArrayInputValue(group, field) {
        let parts = group.split(".");
        group = parts[0];
        var arr = this.state[group];

        if (parts[1] != undefined) {
            if (parts[2] == undefined) {
                arr = arr[parts[1]];
            }
            else if (parts[3] == undefined) {
                arr = arr[parts[1]][parts[2]];
            }
            else if (parts[4] == undefined) {
                arr = arr[parts[1]][parts[2]][parts[3]];
            }
        }

        return arr[field] != undefined ? arr[field] : null
    }

    buildArrayInputs(group, field, label, options = {}, handleClose = true, handleAdd = true) {

        let arr = this.state[group];
        if (arr[field] == undefined) {
            return '';
        }

        return <ArrayInput field={field}
                           group={group}
                           label={label}
                           items={arr[field]}
                           options={options}
                           formHandler={this}
                           getFieldDecorator={this.props.form.getFieldDecorator}
                           handleClose = {handleClose}
                           handleAdd = {handleAdd}
                           removeArrayInput={(field, index, j = null)=>{
                               if(handleClose){
                                    this.removeArrayInput(group, field, index, j = null);
                               }
                           }}
                           updateArrayValue={(field, i, value, j = null) => {
                                this.updateArrayValue(group, field, i, value, j);
                           }}
            />;
    }

    removeArrayInput(group, field, index, innerIndex = null) {
        let arr = this.state[group];
        if (arr[field] == undefined) {
            return '';
        }
        if (innerIndex) {
            arr[field][index].splice(innerIndex, 1);
        }
        else {
            arr[field].splice(index, 1);
        }
        this.update(group + "." + field, arr[field]);
    }

    update(field, value) {
        let fieldParts = field.split('.');
        let group = fieldParts[0];

        if (fieldParts.length > 1) {

            let data = this.state[group];
            if (typeof data == typeof []) {
                if (data.length < 1) {
                    data = {};
                }
            }
            updateDotted(field, data, 1, value);
            let st = {};
            st[group] = data;
            this.setState(st);
        }
        else {
            let arr = this.state;
            if (typeof arr == typeof []) {
                if (arr.length < 1) {
                    arr = {};
                }
            }
            arr[field] = value;
            this.setState(arr);
        }
    }

    updateArrayValue(group, field, i, value, j = null) {
        let arr = this.state[group];
        if (arr[field] == undefined || arr[field][i] == undefined) {
            return '';
        }
        if (j) {
            arr[field][i][j] = value;
        }
        else {
            arr[field][i] = value;
        }
        this.update(group + "." + field, arr[field]);
    }


    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({},
                this.state
            ));
        })
    }
}

export default Form.create({name: 'horizontal_login'})(GeneralForm);



// WEBPACK FOOTER //
// ./src/containers/Pages/Forms/GeneralForm.js